import { isNullOrUndefined } from '@agilepoint/utils-common';
import { messages } from './messages';

export function required(value: any) {
    if (isNullOrUndefined(value) || !value) {
        return messages.required;
    }
    return undefined;
}
